import { motion } from "framer-motion";
import CountUp from "react-countup";
import { CalendarClock, Layers, Users, Globe2 } from "lucide-react";

const stats = [
  { value: 15, suffix: "+", label: "Years Experience", icon: CalendarClock, accent: "#1F5EFF" },
  { value: 500, suffix: "+", label: "Projects Delivered", icon: Layers, accent: "#6D28D9" },
  { value: 50, suffix: "+", label: "Publishing Experts", icon: Users, accent: "#00B8A9" },
  { value: 99, suffix: "%", label: "On-Time Delivery", sub: "Serving global clients from India", icon: Globe2, accent: "#0B1F3A" },
];

export default function Highlights() {
  return (
    <section data-testid="highlights-section" className="relative py-16 sm:py-20 bg-[#F8FAFC]">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
          {stats.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.label}
                data-testid={`highlight-counter-${i}`}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.08, duration: 0.55 }}
                className="lift-card relative rounded-3xl bg-white border border-[#0B1F3A]/10 p-7"
              >
                <div
                  className="inline-flex h-11 w-11 items-center justify-center rounded-xl mb-5"
                  style={{ backgroundColor: `${s.accent}14`, color: s.accent }}
                >
                  <Icon className="h-5 w-5" />
                </div>
                <div className="font-display text-5xl sm:text-6xl font-bold text-[#0B1F3A] tracking-tighter">
                  <CountUp end={s.value} duration={2.2} enableScrollSpy scrollSpyOnce />
                  <span>{s.suffix}</span>
                </div>
                <div className="mt-2 text-[15px] font-semibold text-[#0B1F3A]">{s.label}</div>
                {s.sub && <div className="text-[13px] text-[#475569] mt-0.5">{s.sub}</div>}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
